// extracted by mini-css-extract-plugin
export var accent = "#00cc6d";
export var after = "sidenote-module--after--59bef";
export var anchor = "sidenote-module--anchor--2836b";
export var before = "sidenote-module--before--3b1ad";
export var container = "sidenote-module--container--9ad23";
export var highlight = "sidenote-module--highlight--40462";
export var long = "sidenote-module--long--6e267";
export var sidenote = "sidenote-module--sidenote--46c74";